<!-- Shell: header, entity line, body (main vs entity modals), nested NOL, footers.
     Markup lives in ./fragments/* for maintainability. -->

<div class="modal-header tax-attributes-modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="cursor: pointer;"
       (click)="toggleMinimise($event)"
       title="Minimise"></i>
    <i class="fa fa-times"
       style="cursor: pointer;"
       (click)="cancel()"
       title="Close"></i>
  </div>
</div>

<app-tax-attributes-entity-info [ctx]="vm"></app-tax-attributes-entity-info>

<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <app-tax-attributes-main-panel [ctx]="vm"></app-tax-attributes-main-panel>

  @if (modalName == 'taxAttribEntityModal') {
<div class="tax-attrib-entity-modal">
    <!-- Update/Merge only: sub-tabs for Update vs Posting. Create Entity: no tabs (clean layout). -->
    @if (gridRowData) {
<ul class="nav nav-pills" role="tablist" [hidden]="minimise">
      <li [class.active]="currentTabName === 'UpdateTab'">
        <a (click)="clickEntityTab('update')" class="btn-sm" style="cursor: pointer;">Update Entity</a>
      </li>
      <li [class.active]="currentTabName === 'PostingTab'">
        <a (click)="clickEntityTab('posting')" class="btn-sm" style="cursor: pointer;">Posting Entity</a>
      </li>
    </ul>
}

    @if (currentTabName === 'UpdateTab' && !gridRowData) {
<app-tax-attributes-entity-create-form
     
      [ctx]="vm">
    </app-tax-attributes-entity-create-form>
}

    @if (currentTabName === 'UpdateTab' && gridRowData) {
<app-tax-attributes-entity-update-form
     
      [ctx]="vm">
    </app-tax-attributes-entity-update-form>
}

    @if (currentTabName === 'PostingTab') {
<div style="margin-left: 15px; margin-right: 15px; margin-top: 15px;">
      <app-tax-attributes-entity-posting-form [ctx]="vm"></app-tax-attributes-entity-posting-form>
    </div>
}
  </div>
}
</div>

<app-tax-attributes-nested-nol [ctx]="vm"></app-tax-attributes-nested-nol>

@if (modalName === 'taxAttribModal') {

  <div class="modal-footer tax-attributes-modal-footer" [hidden]="minimise">
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>

}

@if (modalName === 'taxAttribEntityModal' && currentTabName !== 'PostingTab') {

  <div class="modal-footer tax-attributes-modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="reset-button" type="button" (click)="reset()">Reset</button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>

}

@if (modalName === 'taxAttribEntityModal' && currentTabName === 'PostingTab') {

  <div class="modal-footer tax-attributes-modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" [disabled]="!postingMESelected || crudLoading" (click)="savePostingEntity()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save Posting Key
    </button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>

}
